import { render } from "./SecurityLoginHistoryView.vue?vue&type=template&id=04f4a7d8&scoped=true"
import script from "./SecurityLoginHistoryView.vue?vue&type=script&lang=js"
export * from "./SecurityLoginHistoryView.vue?vue&type=script&lang=js"

import "./SecurityLoginHistoryView.vue?vue&type=style&index=0&id=04f4a7d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f4a7d8"]])

export default __exports__